// src/App.js
import React, { useEffect, useState } from 'react';
import BabylonScene from './components/BabylonScene';
import './App.css';

function App() {
  const modelUrl = "total.glb"; // Remplacez par l'URL de votre modèle GLTF
  const [adresse, setAdresse] = useState("-")


  React.useEffect(() => {

    // Obtenir le protocole (http ou https)
    var protocol = window.location.protocol;

    // Obtenir le nom de domaine (par exemple, www.example.com)
    var hostname = window.location.hostname;

    // Obtenir le port (par exemple, 80, 443, ou un port personnalisé)
    var port = window.location.port;

    // Combiner pour obtenir l'adresse complète du serveur
    var serverAddress = protocol + "//" + hostname;

    // Ajouter le port si nécessaire (certains navigateurs ne le montrent que si non standard)
    if (port) {
      serverAddress += ":" + port;
    }
    console.log(serverAddress)
    setAdresse(serverAddress)
  }, []);

  return (
    <div className="App">
      <div className="Babylon-container" style={{ width: '100vw', height: '100vh' }}>
        <BabylonScene/>
      </div>
    </div>
  );
}

export default App;
